<template>
  <div>
    <h3>寻样确认</h3>
    <div
      class="confirm-box"
      v-for="(item, index) in tableData"
      :key="index"
    >
      <div>
        <el-image
          v-if="item.mainImage"
          style="width: 80px; height: 80px"
          :src="item.mainImage + $ImgQuality30"
          :preview-src-list="[item.mainImage + $ImgPreviewQuality]"
          fit="contain">
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
        <p v-else style="width: 80px"></p>
      </div>
      <!-- 原料类型 -->
      <el-form
        v-if="item.sampleType === 'RAW_MATERIAL'"
        class="confirm-info-form"
        ref="confirmInfoForm"
        :model="item"
        :inline="true"
        label-width="148px"
        size="mini"
        :rules="rules"
      >
        <el-row>
          <el-col
            :span="7"
            v-for="(el, index) in tableFormData"
            :key="index"
          >
            <el-form-item :label="el.label" :prop="el.prop">
              <span style="word-break: break-all;">{{item[el.prop]}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :rules="[
                { required: true, message: '请选择回复到样日期', trigger: 'blur' },
              ]"
              label="回复到样日期"
              prop="actualArrivalTime"
            >
              <el-date-picker
                v-model="item.actualArrivalTime"
                type="datetime"
                placeholder="选择时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="right"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              prop="supplierRemark"
              label="备注"
            >
              <el-input
                type="textarea"
                v-model="item.supplierRemark"
                maxlength="30"
                show-word-limit
                style="width: 220px"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 非原料类型 -->
      <el-form
        v-else
        class="confirm-info-form"
        ref="confirmInfoForm"
        :model="item"
        :inline="true"
        label-width="148px"
        size="mini"
        :rules="rules"
      >
        <el-row>
          <el-col
            :span="7"
            v-for="(el, index) in tableFormData"
            :key="index"
          >
            <el-form-item :label="el.label" :prop="el.prop">
              <span style="word-break: break-all;">{{item[el.prop]}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="样品是否可稳定供应" prop="stableSupplyFlag">
              <el-radio-group v-model="item.stableSupplyFlag">
                <el-radio label="YES">是</el-radio>
                <el-radio label="NO">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="item.stableSupplyFlag === 'YES'">
            <el-form-item
              :rules="[
                { required: true, message: '请选择回复到样日期', trigger: 'change' },
              ]"
              label="回复到样日期"
              prop="actualArrivalTime"
            >
              <el-date-picker
                v-model="item.actualArrivalTime"
                type="datetime"
                placeholder="选择时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="right"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="item.stableSupplyFlag === 'YES'">
            <el-form-item
              prop="supplierRemark"
              label="备注"
            >
              <el-input
                type="textarea"
                v-model="item.supplierRemark"
                maxlength="30"
                show-word-limit
                style="width: 220px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="item.stableSupplyFlag === 'NO'">
            <el-form-item
              prop="stableSupplyReason"
              label="原因说明"
              :rules="[
                { required: true, message: '请填写原因说明', trigger: 'blur' },
              ]"
            >
              <el-input
                type="textarea"
                v-model="item.stableSupplyReason"
                maxlength="30"
                show-word-limit
                style="width: 220px"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btns">
      <el-button type="primary" @click="save" :loading="saveLoading">提交</el-button>
      <el-button @click="back">取消</el-button>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';

export default {
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      saveLoading: false,
      tableFormData: [
        { label: '寻样单编号', prop: 'code' },
        { label: '产品名称', prop: 'productName' },
        { label: '产品ID', prop: 'id' },
        { label: '申请时间', prop: 'createDate' },
        { label: '数量', prop: 'num' },
        { label: '单位', prop: 'orderUnit' },
        { label: '采购备注', prop: 'forSupplierRemark' },
        { label: '要求到样日期', prop: 'askArrivalTime' }
      ],
      tableData: [],
      rules: {
        stableSupplyFlag: [
          { required: true, message: '请选择样品是否可稳定供应', trigger: 'change' },
        ]
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    // table数据
    getListForm(val) {
      this.tableData = cloneDeep(val);
      this.clearProductInfoForm();
    },
    save() {
      const vaild = this.checkFormValid();
      if(!vaild) return false;
      // 校验回复到样时间不能为空
      /* let params = this.tableData;
      const errArr1 = params.filter(
        item => item.actualArrivalTime === '' || !item.actualArrivalTime,
      );
      if (errArr1.length > 0) {
        this.$message.error(
          `产品名称为【${errArr1[0].productName}】的商品，回复到样时间不能为空`,
        );
        return;
      }
      const errArr2 = params.reduce((prev, cur) => {
        if (dayjs(cur.actualArrivalTime).isBefore(dayjs(cur.createDate))) {
          prev.push(cur);
        }
        return prev;
      }, []);
      if (errArr2.length > 0) {
        this.$message.error(
          `产品名称为【${errArr2[0].productName}】的商品，回复到样时间不能早于申请时间`,
        );
        return;
      } */

      this.saveLoading = true;
      this.$http.sample
        .batchAddConfirmInfoOrderList(this.tableData)
        .then(() => {
          this.$message.success('操作成功');
          this.back();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    // 表单校验
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    // 清空form表单
    clearProductInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.clearValidate();
        });
      });
    },
    back() {
      this.tableData = [];
      this.removeTab('listBill', 'list');
    },
  },
};
</script>

<style lang="less" scoped>
h3 {
  text-align: center;
}
/deep/ .confirm-box {
  display: flex;
  border-bottom: 1px dashed #ccc;
  padding: 10px 20px 10px;
  .confirm-info-form {
    margin-left: 20px;
    .el-form-item {
      margin-bottom: 5px;
    }
    .el-form-item__content {
      width: calc(100% - 148px);
    }
  }
}
.btns {
  text-align: center;
  padding: 20px 0;
}
</style>
